<template>
  <div class="default-header" :class="isAdmin ? 'admin-menu' : 'user-menu'">
    <v-app-bar
      app
      color="primary"
      clipped-left
      dense
      :width="drawer ? '210' : '56'"
      :collapse="
        !drawer &&
        !$vuetify.breakpoint.xs &&
        !$vuetify.breakpoint.sm &&
        !$vuetify.breakpoint.md
      "
      class="menu-app-bar"
    >
      <div class="col-sm-3 px-0">
        <v-app-bar-nav-icon
          @click.stop="closedrawer"
          class="drawer-color"
        ></v-app-bar-nav-icon>
      </div>
      <div class="col-sm-6 text-center size-pc-min">
        <img alt="Vue logo" src="@/assets/header_logo.png" height="27.04px" />
      </div>
      <div class="col-sm-3 size-pc-min">
        <v-toolbar-title class="logout-show justify-end pr-1">
          <!-- <div class="px-4 login-info col-sm-11">
          <span>{{ company_name }}</span>
          <span>{{ representative + " 様" }}</span>
        </div> -->
          <svg-icon
            :iconClass="isAdmin ? 'logout_logo' : 'logout_logo_blue'"
            class="toolbar-title"
            @click="logoutClick"
          />
        </v-toolbar-title>
        <!-- <v-toolbar-title
          class="text-right size-pc-min justify-end"
          v-if="isAdmin"
        >
          <svg-icon
            iconClass="logout_logo"
            class="toolbar-title"
            @click="logoutClick"
          />
        </v-toolbar-title> -->
      </div>
    </v-app-bar>
    <v-navigation-drawer
      app
      v-model="drawer"
      clipped
      width="210"
      color="primary"
      class="menu-navigation"
    >
      <v-list
        v-for="(item, index) in isAdmin ? adminMenuItems : userMenuItems"
        :key="index"
        subheader
        dense
        class="menu-list"
      >
        <v-subheader dense class="menu-subheader">{{ item.title }}</v-subheader>
        <v-list-item-group :class="item.disable ? 'menu-disable' : ''">
          <template v-for="(subItem, subIndex) in item.subItems">
            <v-list-item
              v-if="subItem.subItemFlg !== 1"
              :class="
                subItem.disable
                  ? 'menu-list-item menu-disable'
                  : 'menu-list-item'
              "
              :key="subIndex"
              link
              :to="subItem.link"
              @click="subItem.isLogout ? logoutClick() : {}"
            >
              <v-list-item-icon class="menu-icon">
                <svg-icon :iconClass="subItem.icon" :class="subItem.resize" />
              </v-list-item-icon>
              <v-list-item-content class="menu-content">
                <v-list-item-title class="menu-title">{{
                  subItem.title
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-group
              v-else
              :key="subIndex"
              no-action
              class="menu-list-group-item"
            >
              <template v-slot:prependIcon>
                <v-list-item-icon class="group-menu-icon">
                  <svg-icon :iconClass="subItem.icon" :class="subItem.resize" />
                </v-list-item-icon>
              </template>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="(subItem, subIndex) in subItem.subItems"
                :key="subIndex"
                link
                :to="subItem.link"
              >
                <v-list-item-title>{{ subItem.title }}</v-list-item-title>
              </v-list-item>
            </v-list-group>
          </template>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-main :class="mainContentClass">
      <router-view :key="currentPath" />
      <v-overlay
        :value="loading"
        color="white"
        class="text-center"
        opacity="1"
        z-index="3"
      >
        <v-progress-circular
          :size="53"
          :width="5"
          color="primary"
          indeterminate
          class="ml-1"
        ></v-progress-circular>
        <div class="loading-text">Loading...</div>
      </v-overlay>
    </v-main>
    <confirm-dialog
      icon="mdi-alert-outline"
      :iconColor="isAdmin ? '#366EB7' : '#5FBC6F'"
      text="ログアウトしますか？"
      :show="confirmDialogShow"
      @yes="logoutConfirmed"
      @cancel="confirmDialogShow = false"
    ></confirm-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";
import { USERTAB } from "@/utils/mst-user";
import { logout } from "@/api/common";

export default {
  name: "SideMenu",
  components: {
    ConfirmDialog
  },
  computed: {
    ...mapGetters(["getLoading"]),
    currentPath() {
      return this.$route.path;
    },
    isAdmin() {
      return this.$route.path.startsWith("/admin");
    },
    loading() {
      return this.getLoading;
    },
  },
  created: async function () {
    await this.refresh();
  },
  data: () => ({
    // 左メニューが見えるかどうか
    drawer: true,
    // ログアウトの確認ポップアップ
    confirmDialogShow: false,
    mainContentClass: "page-main-content",
    usercode: USERTAB,
    // 管理者メニューアイテム
    adminMenuItems: [
      {
        isGroup: true,
        title: "ユーザー・組合員管理",
        subItems: [
          {
            title: "ユーザー一覧",
            link: "/admin/users",
            icon: "Icon awesome-user-friends",
            resize: "svg-users"
          },
          {
            title: "ユーザー新規登録",
            link: "/admin/newuser",
            icon: "user-plus-solid",
            resize: "svg-add"
          }
        ]
      }
    ],
    // 普通ユーザーメニューアイテム
    userMenuItems: [],
    company_name: '',
    representative: '',
    loginUser: "",
  }),
  methods: {
    async logoutClick() {
      this.confirmDialogShow = true;
    },
    async logoutConfirmed() {
      if (this.isAdmin) {
        this.loginUser = JSON.parse(localStorage.getItem("adminUserInfo"));
      } else {
        this.loginUser = JSON.parse(localStorage.getItem("userInfo"));
      }
      this.confirmDialogShow = false;
      var params = {
        login: this.loginUser.login,
      }
      await logout(params).then(() => {
        this.$store.commit("SET_USERINFO", {});
        if (this.isAdmin) {
          localStorage.setItem("adminUserInfo", null);
          this.$router.push({
            name: "AdminLogin",// 管理者ログイン画面に遷移
          });
        } else {
          localStorage.setItem("userInfo", null);
          this.$router.push({
            name: "Login",// 利用者ログイン画面に遷移
          });
        }
      });
    },
    refresh() {
      if (this.isAdmin) {
        this.loginUser = JSON.parse(localStorage.getItem("adminUserInfo"));
      } else {
        this.loginUser = JSON.parse(localStorage.getItem("userInfo"));
      }
      if (this.loginUser) {
        if (this.loginUser.user_code == this.usercode.UNION_MEMBER) {
          this.company_name = this.loginUser.company_name;
        } else if (this.loginUser.user_code == this.usercode.SALE_MEMBER) {
          this.company_name = "営業員";
        } else {
          this.company_name = "管理者";
        }
        this.representative = this.loginUser.staff_name;
        if (this.loginUser.user_code == this.usercode.UNION_MEMBER) {
          this.userMenuItems = [
            {
              isGroup: true,
              title: "申請者管理",
              subItems: [
                {
                  title: "申請一覧",
                  link: "/user/certificate",
                  icon: "awesome-list-ul",
                  iconHeight: 15,
                  iconWidth: 15
                }
              ]
            }
          ];
        } else {
          this.userMenuItems = [
            {
              isGroup: true,
              title: "申請者管理",
              subItems: [
                {
                  title: "申請一覧",
                  link: "/user/certificate",
                  icon: "awesome-list-ul",
                  iconHeight: 15,
                  iconWidth: 15
                },
                {
                  title: "新規申請フォーム",
                  link: "/user/new/certificate",
                  icon: "user-plus-solid",
                  resize: "svg-user"
                }
              ]
            }
          ];
        }
      } else {
        if (this.isAdmin) {
          this.$router.push({
            name: "AdminLogin",// 管理者ログイン画面に遷移
          });
        } else {
          this.$router.push({
            name: "Login",// 利用者ログイン画面に遷移
          });
        }
      }
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    closedrawer() {
      this.drawer = !this.drawer;
      const navigationBar = this.$parent;
      if (!this.isMobile()) {
        if (!this.drawer) {
           navigationBar.$refs.punks.classList.add("side_close");
        } else {
          navigationBar.$refs.punks.classList.remove("side_close");
        }
      }
    },
    handleResize() {
      const navigationBar = this.$parent;
      if (!this.isMobile() || window.innerWidth >= 768) {
        if (!this.drawer) {
           navigationBar.$refs.punks.classList.add("side_close");
        } else {
          navigationBar.$refs.punks.classList.remove("side_close");
        }
      } else {
        navigationBar.$refs.punks.classList.remove("side_close");
      }
    }
  },
  async mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
}
</script>

<style lang="scss" scoped>
/* loading... style */
.loading-text {
  font-size: 20px;
  margin-top: 5px;
  color: #d4dceb !important;
}
.login-info {
  display: flex;
  flex-direction: column;
  color: $white;
  font-size: 12px;
}
.menu-disable {
  pointer-events: none !important;
  opacity: 0.5;
}
.size-pc-min {
  display: none;
}
.default-header {
  .menu-app-bar {
    height: 56px !important;
    box-shadow: none !important;
    position: absolute;
    .app-bar-ico {
      color: $white;
    }
    .toolbar-title {
      padding-left: 0 !important;
      font-size: $size-sub-title;
      font-weight: bold;
      height: 16.88px;
      width: 21.67px;
    }
    .v-toolbar__content {
      height: 56px !important;
    }
  }

  .v-toolbar--collapse .v-btn--round {
    margin-left: 0 !important;
  }
  .menu-navigation {
    padding-top: 20px;
    position: absolute;
    min-height: calc(100% - 48px);
    .menu-list {
      border: 1px solid $white;
      border-top-width: 1px;
      margin: 8px 5px 0 5px;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      .menu-subheader {
        height: 2rem;
        color: #211917;
        margin-bottom: 0.5em;
        font-size: $size-normal;
        background-color: $white;
        margin-top: 0;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
      }
      .menu-list-item {
        padding: 0 10px;
        .menu-icon {
          display: flex;
          align-items: center;
          margin-right: 5px;
          color: $admin-color-title;
          font-size: 12px;
          .svg-user-friends {
            width: 19px;
            height: 13px;
          }
          .svg-user {
            color: $white;
            width: 20.38px;
            height: 16.98px;
          }
          .svg-users {
            width: 20.25px;
            height: 14.18px;
          }
          .svg-add {
            width: 20.38px;
            height: 16.98px;
          }
        }
        .menu-content {
          padding: 3px 0 0;
          .menu-title {
            color: $black;
            font-size: $size-normal;
          }
        }
      }
    }
  }
}
.user-menu {
  .drawer-color {
    color: $white;
    padding-right: 12px;
    padding-left: 12px;
  }
  .toolbar-title {
    color: $white !important;
  }
}
.admin-menu {
  .drawer-color {
    color: $black;
  }
  .toolbar-title {
    color: $admin-secondary !important;
  }
}
.admin-menu .menu-navigation {
  .menu-list {
    border: 1px solid $black;
    .menu-subheader {
      color: $white;
      background-color: $black;
    }
  }
}
.user-menu .menu-content .menu-title {
  color: $white !important;
  padding-bottom: 1px;
}

@media screen and (max-width: $size-pc) {
  .menu-app-bar {
    width: auto !important;
  }
}
@media screen and (max-width: $size-pc-min) {
  .size-pc-min {
    display: block;
  }
  .logout-show {
    width: -webkit-fill-available;
    align-items: center;
    display: flex;
  }
  .v-toolbar__title {
    overflow: unset;
  }
  .user-menu {
    .drawer-color {
      color: $dark-blue;
    }
  }
}
</style>

<style lang="scss">
.default-header {
  .page-main-content {
    .v-main__wrap {
      padding-left: 40px;
      padding-right: 20px;
      // padding-bottom: 10px;
      padding-bottom: 98px;
    }
  }
  .page-main-content-full {
    .v-main__wrap {
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 90px;
    }
  }
  .v-navigation-drawer__content {
    margin-top: -16px;
  }
  @media screen and (max-width: $size-mobile) {
    .drawer-color {
      color: $dark-blue !important;
    }
    .v-navigation-drawer__content {
      padding-bottom: 115px;
      margin-top: 28px;
    }
    .page-main-content {
      padding: 0px 0px 0px !important;
      .v-main__wrap {
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 10px;
      }
    }
    .page-main-content-full {
      .v-main__wrap {
        padding-left: 0;
        padding-right: 0;
        padding-bottom: 90px;
      }
    }
    .v-toolbar__content {
      .mobile-size {
        display: flex !important;
        flex-grow: 1;
        justify-content: center;
        font-size: $size-normal !important;
        font-weight: bold;
        font-family: "Noto Sans CJK JP", sans-serif !important;
      }
    }
  }
  @media screen and (max-width: $size-pc-min) {
    .v-navigation-drawer__content {
      margin-top: 28px;
    }
  }
  .menu-list-group-item {
    .v-list-group__header {
      padding: 0 10px;
      .v-list-group__header__prepend-icon {
        padding: 0;
        margin: 0 !important;
        .group-menu-icon {
          display: flex;
          align-items: center;
          margin-right: 5px;
          color: $white;
          font-size: 12px;
          .svg-settings {
            width: 17px;
            height: 17px;
          }
        }
      }
      .v-list-item__title {
        color: $white;
        font-size: $size-normal;
      }
      .v-list-group__header__append-icon {
        .v-icon {
          color: $white;
        }
      }
    }
    .v-list-group__items {
      .v-list-item {
        padding-left: 25px !important;
        .v-list-item__title {
          color: $white;
          font-size: $size-normal;
        }
      }
    }
  }
}

/*マウスオーバー・選択時の背景デザインカラー*/
.default-header {
  .theme--light.v-list-item--active::before {
    opacity: 1;
    z-index: -1;
  }
  .v-toolbar__content {
    height: 56px !important;
    padding: 0;
  }
  .v-toolbar.v-toolbar--collapsed {
    border-radius: 50% !important;
    top: 1px !important;
    left: 20px !important;
    justify-content: center;
    display: flex;
  }
}
.default-header.user-menu {
  .v-list-item--link {
    &:hover {
      background: $user-hover-color;
      margin-top: 2px;
    }
    &::before {
      background: $user-hover-color;
      margin-top: 2px;
    }
  }
}
.default-header.admin-menu {
  .v-list-item--link {
    &:hover {
      background: $admin-hover-color !important;
      margin-top: 2px;
    }
    &::before {
      background: $admin-hover-color !important;
      margin-top: 2px;
    }
  }
}
</style>